import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import Select from "react-select";
import { useReactToPrint } from "react-to-print";
import XlsxPopulate from "xlsx-populate";
import { saveAs } from "file-saver";

// reactstrap components
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  FormGroup,
  Form,
  Row,
  Col,
  Input,
} from "reactstrap";

// helpers
import {
  formateDateApi,
  formateDateandTime,
  formateDate,
  formateDateSemBarra,
} from "helpers/formats";

// services
import { api_POST } from "../../../services/api_service.js";
import { api_GET } from "../../../services/api_service.js";
import { showMessage } from "../../../services/message.js";

//Context
import { useAuth } from "../../../context/auth.js";

export default function RelatorioCadastroGeradores({ handleReturn }) {
  const { session, setLoading } = useAuth();

  const { register, handleSubmit, errors, setValue, clearErrors, getValues } = useForm({
    mode: "onBlur",
  });

  const [relatorio, set_relatorio] = useState(null);

  const [optionsTipoCadastro, setOptionsTipoCadastro] = useState([]);

  const [optionsModalidades, setOptionsModalidades] = useState([]);

  // options de modalidade
  const [optionsCategorias] = useState([
    { value: "RCC", label: "RCC" },
    { value: "RGG", label: "RGG" },
    { value: "RSS", label: "RSS" },
  ]);

  const [categoria, setCategoria] = useState("RCC");

  const [lista, setLista] = useState([]);

  const [tipoCadastroSelecionadas, setTipoCadastroSelecionadas] = useState([]);

  const [modalidadesSelecionadas, setModalidadesSelecionadas] = useState([]);

  const [statusProtocolo, setStatusProtocolo] = useState("TODOS");

  const [showDetail, set_showDetail] = useState(false);

  const [filtro, set_filtro] = useState(null);

  const componentRef = React.useRef();

  const [options_statusProtocolo] = useState([
    { value: "TODOS", label: "TODOS" },
    { value: "Ativo", label: "Ativo" },
    { value: "Pendente", label: "Pendente" },
    { value: "Vencido", label: "Vencido" },
    { value: "Inativo", label: "Inativo" },
    { value: "Cancelado", label: "Cancelado" },
  ]);

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    copyStyles: true,
  });

  const handleCategoria = (value) => {
    setCategoria(value);
    setValue("categoria", value, true);
    clearErrors("categoria");

  };

  const handleTipoProtocolo = (value) => {
    setStatusProtocolo(value);
    setValue("statusProtocolo", value, true);
    clearErrors("statusProtocolo");
  };

  async function loadTipoCadastroCategoria(categoria) {
    setLoading(true)
    try {
      const { data } = await api_GET("/Categoria");
      if (data && data.length > 0)
        setOptionsTipoCadastro(data.filter(x => x.sigla === categoria && x.segmento === 'Grande Gerador'))
      else
        setOptionsTipoCadastro([])
    } catch (error) {
      showMessage("Error", error?.message ?? "Error na operação", "error", null)
    } finally {
      setLoading(false)
    }
  }

  async function loadModalidadesGeradores() {
    setLoading(true)
    try {
      const { data } = await api_GET("/ProtocoloGerador/GetListModalidades");
      if (data && data.length > 0)
        setOptionsModalidades(data)
      else
        setOptionsModalidades([])
    } catch (error) {
      showMessage("Error", error?.message ?? "Error na operação", "error", null)
    } finally {
      setLoading(false)
    }
  }

  function handleTipoCadastros(value) {
    setTipoCadastroSelecionadas(value);
    setValue("tipoCadastroSelecionadas", value, true);
  }

  function handleModalidades(value) {
    setModalidadesSelecionadas(value);
    setValue("modalidadesSelecionadas", value, true);
  }

  const fetchRelatorioGeradores = async (filtro) => {
    try {
      setLoading(true);
      const { data } = await api_POST("relatorio/RelatorioCadastroGeradores", filtro);
      return data;
    } catch (err) {
      showMessage("Aviso", err.message, "error", null);
      return null;
    } finally {
      setLoading(false);
    }
  };

  const handleExcel = async () => {
    if (tipoCadastroSelecionadas.length === 0) {
      showMessage("Aviso", "Selecione pelo menos um Tipo de Cadastro", "error", null);
      return;
    }

    let _modalidadesSelecionadas = modalidadesSelecionadas
    if (!modalidadesSelecionadas)
      _modalidadesSelecionadas = []

    const filtroApi = {
      status: statusProtocolo,
      categoriasSelecionadas: tipoCadastroSelecionadas.map(({ categoria_Id }) => categoria_Id),
      modalidadesSelecionadas: _modalidadesSelecionadas,
    };

    const resultado = await fetchRelatorioGeradores(filtroApi);

    if (!!resultado) {
      filtroApi.nome = session.nome;
      set_filtro({ ...filtroApi, categoriasSelecionadas: tipoCadastroSelecionadas });
      setLista(resultado?.geradores || []);
      set_showDetail(true);
    } else {
      setLista([]);
      set_showDetail(false);
    }
  };

  const onSubmit = async (data) => {
    setLista([]);
    set_showDetail(false)

    if (tipoCadastroSelecionadas.length === 0) {
      showMessage("Aviso", "Selecione pelo menos um Tipo de Cadastro", "error", null);
      return;
    }

    let _modalidadesSelecionadas = modalidadesSelecionadas
    if (!modalidadesSelecionadas)
      _modalidadesSelecionadas = []

    const filtroApi = {
      status: statusProtocolo,
      categoriasSelecionadas: tipoCadastroSelecionadas.map(({ categoria_Id }) => categoria_Id),
      modalidadesSelecionadas: _modalidadesSelecionadas,
    };

    const resultado = await fetchRelatorioGeradores(filtroApi);

    if (resultado) {
      filtroApi.nome = session.nome;
      set_filtro({
        ...filtroApi,
        categoriasSelecionadas: tipoCadastroSelecionadas
      });
      set_relatorio(resultado);
    } else {
      set_relatorio(null)
    }
  };



  useEffect(() => {
    if (!!categoria)
      loadTipoCadastroCategoria(categoria)

    if (categoria == "RGG")
      loadModalidadesGeradores()
  }, [categoria])

  return (
    <>
      <div className="content">
        <Row>
          <Col md="6" className="noPrint">
            <Button color="Primary" onClick={handleReturn}>
              <i className="fas fa-chevron-left"></i> Voltar
            </Button>
          </Col>
          {relatorio != null && !showDetail && (
            <Col md="6" className="text-right noPrint">
              <Button color="danger" onClick={handlePrint}>
                <i className="fas fa-print"></i>
              </Button>
            </Col>
          )}
        </Row>
        {relatorio == null && (
          <Row>
            <Col md="12">
              <Card>
                <CardHeader>
                  <Row>
                    <Col md="9">
                      <h4 className="mb-0 mt-0">
                        Relatório Cadastro de Geradores
                      </h4>
                      <label className="rel-subtitle">
                        Relatório Detalhado de Cadastro de Geradores.
                      </label>
                    </Col>
                  </Row>
                </CardHeader>
                <CardBody>
                  <Form onSubmit={handleSubmit(onSubmit)}>
                    <Row className="noPrint">
                      <Col lg="6" md="12">
                        <FormGroup>
                          <label className="form-control-label mt-1">
                            Status Protocolo:
                          </label>
                          <Select
                            options={options_statusProtocolo}
                            name="statusProtocolo"
                            onChange={(e) => {
                              handleTipoProtocolo(e.value);
                            }}
                            value={
                              statusProtocolo !== "" &&
                              options_statusProtocolo.find(
                                (obj) => obj.value === statusProtocolo
                              )
                            }
                            placeholder="Selecione"
                            ref={(e) =>
                              register(
                                { name: "statusProtocolo" },
                                { required: false }
                              )
                            }
                          />
                        </FormGroup>
                      </Col>

                      <Col lg="6" md="12">
                        <FormGroup>
                          <label className="form-control-label mt-1">
                            Categoria:
                          </label>
                          <Select
                            options={optionsCategorias}
                            name="categoria"
                            onChange={(e) => {
                              setTipoCadastroSelecionadas([]);
                              setValue("tipoCadastroSelecionadas", [], true);

                              handleCategoria(e.value);
                            }}
                            value={categoria !== "" &&
                              optionsCategorias.find(
                                (obj) => obj.value === categoria
                              )}
                            placeholder="Selecione"
                            ref={(e) =>
                              register(
                                { name: "categoria" },
                                { required: false }
                              )
                            }
                          />
                        </FormGroup>
                      </Col>

                      {optionsTipoCadastro.length > 0 &&
                        <Col lg="12" md="12">
                          <FormGroup>
                            <label className="form-control-label">
                              Tipo de Cadastro:
                            </label>
                            <Select
                              options={optionsTipoCadastro}
                              getOptionLabel={(e) => e.descricao}
                              getOptionValue={(e) => e.categoria_Id}
                              name="tipoCadastroSelecionadas"
                              onChange={(e) => {
                                handleTipoCadastros(e);
                              }}
                              value={tipoCadastroSelecionadas}
                              placeholder="Selecione"
                              isMulti
                              ref={(e) =>
                                register(
                                  { name: "tipoCadastroSelecionadas" },
                                  { required: true }
                                )
                              }
                            />
                            {errors.tipoCadastroSelecionadas && (
                              <span className="form-control-label text-danger">
                                * Campo Obrigatório
                              </span>
                            )}
                          </FormGroup>
                        </Col>
                      }

                      {optionsModalidades.length > 0 &&
                        <Col lg="12" md="12">
                          <FormGroup>
                            <label className="form-control-label">
                              Modalidades:
                            </label>
                            <Select
                              options={optionsModalidades}
                              getOptionLabel={(modalidade) => modalidade}
                              getOptionValue={(modalidade) => modalidade}
                              name="modalidadesSelecionadas"
                              onChange={(e) => {
                                handleModalidades(e);
                              }}
                              value={modalidadesSelecionadas}
                              placeholder="Selecione"
                              isMulti
                              ref={(e) =>
                                register(
                                  { name: "modalidadesSelecionadas" },
                                  { required: false }
                                )
                              }
                            />
                          </FormGroup>
                        </Col>}
                      <Col lg="2" md="2" sm="12">
                        <Button
                          color="info"
                          className="btn-mobile"
                          type="submit"
                        >
                          {" "}
                          Gerar Relatório
                        </Button>
                      </Col>
                      <Col lg="2" md="2" sm="12">
                        <Button color="danger" className="btn-mobile" type="button" onClick={handleExcel}>
                          Gerar Excel
                        </Button>
                      </Col>
                    </Row>
                  </Form>
                </CardBody>
              </Card>
            </Col>
          </Row>
        )}
        {!showDetail && relatorio && (
          <Row>
            <Col md="12">
              <Card>
                <CardBody>
                  <ComponentToPrint
                    relatorio={relatorio}
                    filtro={filtro}
                    ref={componentRef}
                  />
                </CardBody>
              </Card>
            </Col>
          </Row>
        )}
        {showDetail && lista.length > 0 && (
          <Row>
            <Col md="12">
              <ComponentToExcel
                relatorio={lista}
                filtro={filtro}
                ref={componentRef}
              />
            </Col>
          </Row>
        )}
      </div>
    </>
  );
}

export const ComponentToPrint = React.forwardRef((props, ref) => {
  const relatorio = props.relatorio;
  const filtro = props.filtro;
  return (
    <div ref={ref}>
      <div className="row">
        <div className="col-9">
          <h4 className="mb-0 mt-0">Relatório Cadastro de Geradores</h4>
          <label>
            Relatório Detalhado de Cadastro de Geradores.
          </label>
        </div>
        <div className="col-3 text-right">
          <label>Gerado em {formateDateandTime(new Date())}</label>
        </div>
      </div>
      {filtro != null && (
        <div className="row rel-filter">
          <div className="col-6">
            <span>
              <b>Gerado Por</b>
            </span>
            <br />
            <span>{filtro.nome}</span>
          </div>
          <div className="col-6">
            <span>
              <b>Status Protocolo</b>
            </span>
            <br />
            <span>{filtro.status}</span>
          </div>
          <div className="col-6">
            <span>
              <b>Tipo de Cadastro</b>
            </span>
            <br />
            <span>{filtro.categoriasSelecionadas.length > 0 ? filtro.categoriasSelecionadas.map(({ descricao }) => descricao).join("; ") : ""}</span>
          </div>
          {
            (filtro?.modalidadesSelecionadas || []).length > 0 &&
            <div className="col-6">
              <span>
                <b>Modalidades</b>
              </span>
              <br />
              <span>{(filtro.modalidadesSelecionadas || []).join("; ")}</span>
            </div>
          }
        </div>
      )}
      {relatorio != null && (
        <>
          <h5>
            <strong>Total de Geradores: {relatorio.totalGeradores}</strong>
          </h5>

          {relatorio.geradores.map((m, key) => (
            <div className="rel-group" key={key}>
              <div className="row rel-item">
                <div className="col-6">
                  <span><b>Status Protocolo: </b></span>
                  <span>{m?.status}</span>
                </div>
                <div className="col-6">
                  <span><b>Código: </b></span>
                  <span>{" " + m.codigoCadastro}</span>
                </div>
                <div className="col-6">
                  <span><b>Razão Social: </b></span>
                  <span>{" " + m.razaoSocial}</span>
                </div>
                <div className="col-6">
                  <span><b>Nome Fantasia: </b></span>
                  <span>{" " + m.nomeFantasia}</span>
                </div>
                <div className="col-6">
                  <span><b>Responsável Legal: </b></span>
                  <span>{" " + m.responsavelLegal}</span>
                </div>
                <div className="col-6">
                  <span><b>CNPJ: </b></span>
                  <span>{" " + m.cnpj}</span>
                </div>
                <div className="col-3">
                  <span><b>Telefone: </b></span>
                  <span>{" " + m.telefoneContato}</span>
                </div>
                <div className="col-3">
                  <span><b>E-mail: </b></span>
                  <span>{" " + m.emailCadastrado}</span>
                </div>
                {!!m.ramoAtividade &&
                  <div className="col-6">
                    <span><b>Ramo de Atividade: </b></span>
                    <span>{" " + m.ramoAtividade}</span>
                  </div>
                }
                <div className="col-6">
                  <span><b>Tipo de Cadastro: </b></span>
                  <span>{" " + m.tipoCadastro}</span>
                </div>
                {!!m.modalidades &&
                  <div className="col-6">
                    <span><b>Modalidades: </b></span>
                    <span>{" " + m.modalidades}</span>
                  </div>
                }
                {!!m.transportadores &&
                  <div className="col-6">
                    <span><b>Transportadores: </b></span>
                    <span>{" " + m.transportadores}</span>
                  </div>
                }
                <div className="col-6">
                  <span><b>Data de Validade do Cadastro: </b></span>
                  <span>
                    {" " +
                      (m.dataValidadeCadastro
                        ? new Date(m.dataValidadeCadastro).toLocaleDateString("pt-BR")
                        : "-")}
                  </span>
                </div>
              </div>
            </div>
          ))}
        </>
      )}


    </div>
  );
});

export const ComponentToExcel = React.forwardRef((props, ref) => {
  const relatorio = props.relatorio;

  const x = relatorio.map((val) => [
    val.razaoSocial,
    val.nomeFantasia,
    val.cnpj,
    val.codigoCadastro,
    val.responsavelLegal,
    val.status,
    val.tipoCadastro,
    val.ramoAtividade,
    val.telefoneContato,
    val.emailCadastrado,
    val.modalidades,
    val.transportadores,
    val.dataValidadeCadastro ? new Date(val.dataValidadeCadastro).toLocaleDateString("pt-BR") : null
  ]);


  function getSheetData(data, header) {
    var fields = Object.keys(data[0]);
    var sheetData = data.map(function (row) {
      return fields.map(function (fieldName) {
        return row[fieldName] ? row[fieldName] : "";
      });
    });
    sheetData.unshift(header);
    return sheetData;
  }

  async function saveAsExcel() {
    let header = [
      "Razão Social",
      "Nome Fantasia",
      "CNPJ",
      "Código de Cadastro",
      "Responsável Legal",
      "Status",
      "Tipo de Cadastro",
      "Ramo de Atividade",
      "Telefone de Contato",
      "E-mail Cadastrado",
      "Modalidades",
      "Transportadores",
      "Data de Validade do Cadastro"
    ];


    XlsxPopulate.fromBlankAsync().then(async (workbook) => {
      const dia = new Date();
      const sheet1 = workbook.sheet(0).name("RGG");
      const sheetData = getSheetData(x, header);
      const totalColumns = sheetData[0].length;

      sheet1.cell("A1").value(sheetData);
      const range = sheet1.usedRange();
      const endColumn = String.fromCharCode(64 + totalColumns);
      sheet1.row(1).style("bold", true);
      sheet1.range("A1:" + endColumn + "1");
      return workbook.outputAsync().then((res) => {
        saveAs(
          res,
          "RelatorioCadastroGeradoresRGG_" +
          dia.getDate() +
          (dia.getMonth() + 1) +
          dia.getFullYear() +
          ".xlsx"
        );
      });
    });
  }

  return (
    <>
      <Col md="12" className="text-right noPrint">
        <Button className="btn btn-info" onClick={saveAsExcel}>
          Exportar como XLS
        </Button>
      </Col>
      <Card className="card-stats">
        <CardBody>
          <div className="table-responsive">
            <table id="RGG_Excel" className="table">
              <thead>
                <tr>
                  <th>Razão Social</th>
                  <th>Nome Fantasia</th>
                  <th>CNPJ</th>
                  <th>Código de Cadastro</th>
                  <th>Responsável Legal</th>
                  <th>Status</th>
                  <th>Tipo de Cadastro</th>
                  <th>Ramo de Atividade</th>
                  <th>Telefone</th>
                  <th>E-mail</th>
                  <th>Modalidades</th>
                  <th>Transportadores</th>
                  <th>Data de Validade do Cadastro</th>
                </tr>
              </thead>
              <tbody>
                {relatorio.map((item, index) => (
                  <tr key={index}>
                    <td>{item.razaoSocial}</td>
                    <td>{item.nomeFantasia}</td>
                    <td>{item.cnpj}</td>
                    <td>{item.codigoCadastro}</td>
                    <td>{item.responsavelLegal}</td>
                    <td>{item.status}</td>
                    <td>{item.tipoCadastro}</td>
                    <td>{item.ramoAtividade}</td>
                    <td>{item.telefoneContato}</td>
                    <td>{item.emailCadastrado}</td>
                    <td>{item.modalidades}</td>
                    <td>{item.transportadores}</td>
                    <td>
                      {item.dataValidadeCadastro
                        ? new Date(item.dataValidadeCadastro).toLocaleDateString("pt-BR")
                        : "-"}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

        </CardBody>
      </Card>
    </>
  );
});
